import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import InformationMessage from '../InformationMessage';
import Bus from '../Bus';
import FromToIndicator from '../DestinationFromTo';
import BusSelector from '../BusSelector';
import { __ } from '../../utilities';

const Box = styled.div`
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.color.white};
  margin-left: ${rem(36)};
  margin-right: ${rem(36)};
  margin-top: ${rem(15)};
  margin-bottom: ${rem(15)};
  box-shadow: 0px 2px 12px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: ${rem(30)} ${rem(20)} ${rem(30)} ${rem(20)};
  @media (max-width: 800px) {
    margin-left: ${rem(5)};
    margin-right: ${rem(5)};
  }
`;

class RoundBox extends Component {
  constructor() {
    super();
    this.busSelect = this.busSelect.bind(this);
    this.selectSeat = this.selectSeat.bind(this);
    this.seatsUpdate = this.seatsUpdate.bind(this);
    this.setDefaultSeats = this.setDefaultSeats.bind(this);
    this.state = {
      busDisplayed: 0,
      selectedSeats: {},
      busChoosedId: null,
    };
  }

  componentDidMount() {
    const seats = this.state.selectedSeats;
    this.props.round.buses.forEach(bus => {
      seats[bus.busId] = bus.selectedSeats;
      if (bus.selectedSeats.length !== 0) {
        this.setState({
          busChoosedId: bus.busId,
        });
      }
    });

    this.setDefaultSeats(seats);
  }

  setDefaultSeats(seats) {
    this.setState({
      selectedSeats: seats,
    });
  }

  seatsUpdate(selectedSeats, busId, roundId) {
    const newSeats = this.state.selectedSeats;
    newSeats[busId] = selectedSeats;
    this.setState({
      selectedSeats: newSeats,
      busChoosedId: busId,
    });
    if (selectedSeats.length === 0) {
      this.setState({
        busChoosedId: null,
      });
    }
    this.props.updateSelectedSeats(
      this.state.selectedSeats,
      roundId,
      this.state.travelId,
    );
  }

  selectSeat(seatId, roundId, busId) {
    if (this.state.busChoosedId === busId || this.state.busChoosedId === null) {
      if (!this.state.selectedSeats[busId].includes(seatId)) {
        if (this.state.busChoosedId === null) {
          this.setState({
            busChoosedId: busId,
          });
        }
        const newSelectedSeats = [...this.state.selectedSeats[busId]];

        if (
          !(
            this.props.numberOfSeatsForRound >
            this.state.selectedSeats[busId].length
          )
        ) {
          newSelectedSeats.shift();
        }
        newSelectedSeats.push(seatId);
        this.seatsUpdate(newSelectedSeats, busId, roundId);
      } else if (this.state.selectedSeats[busId].includes(seatId)) {
        const newSelectedSeats = this.state.selectedSeats[busId];
        const index = newSelectedSeats.indexOf(seatId);
        newSelectedSeats.splice(index, 1);
        this.seatsUpdate(newSelectedSeats, busId, roundId);
      }
    } else {
      alert(__('Vyberať miesta je možné iba v jednom autobuse!'));
    }
  }

  busSelect(busIndex) {
    this.setState({
      busDisplayed: busIndex,
    });

    this.setState({
      busDisplayed: busIndex,
    });
  }

  render() {
    const box = [];
    if (this.props.round.buses.length === 0) {
      box.push(
        <InformationMessage
          key={this.props.round.roundId + 1}
          type="warning"
          title={__('Pre tento smer nie je možné vyberať miestenky.')}
        />,
      );
    } else {
      if (this.props.round.buses.length > 1) {
        box.push(
          <InformationMessage
            key={this.props.round.roundId + 2}
            type="info"
            title={__('Táto trasa je posilnená o ďalší autobus.')}
          />,
        );
        box.push(
          <BusSelector
            key={this.props.round.roundId}
            id={this.props.round.roundId}
            buses={this.props.round.buses}
            busDisplayed={this.state.busDisplayed}
            busSelect={e => this.busSelect(e)}
          />,
        );
      }
      this.props.round.buses.forEach((bus, indexOfBus) => {
        box.push(
          <Bus
            key={bus.busId}
            displayed={
              this.state.busDisplayed === indexOfBus &&
              !!this.state.selectedSeats[
                this.props.round.buses[this.state.busDisplayed].busId
              ]
            }
            busId={bus.busId}
            selectedSeats={
              this.state.selectedSeats[
                this.props.round.buses[this.state.busDisplayed].busId
              ]
            }
            selectSeat={e =>
              this.selectSeat(
                e,
                this.props.round.roundId,
                this.props.round.buses[this.state.busDisplayed].busId,
              )
            }
            fromId={this.props.round.from}
            toId={this.props.round.to}
          />,
        );
      });
    }

    return (
      <Box>
        <FromToIndicator
          from={this.props.round.fromLabel}
          to={this.props.round.toLabel}
          font={24}
        />
        {box}
      </Box>
    );
  }
}

RoundBox.propTypes = {
  round: PropTypes.shape({
    from: PropTypes.number,
    fromLabel: PropTypes.string,
    toLabel: PropTypes.string,
    to: PropTypes.number,
    roundId: PropTypes.roundId,
    buses: PropTypes.arrayOf(
      PropTypes.shape({
        busId: PropTypes.number,
      }),
    ),
  }),
  numberOfSeatsForRound: PropTypes.number,
  updateSelectedSeats: PropTypes.func,
};

RoundBox.defaultProps = {
  round: {},
  numberOfSeatsForRound: 0,
  updateSelectedSeats: () => {},
};

const connectedRoundBox = connect()(RoundBox);

export default withTheme(connectedRoundBox);



// WEBPACK FOOTER //
// ./src/components/RoundBox/roundBox.js